<template>
    <q-card>
        <q-card-section>
            <div class="text-h6">{{ name }}</div>
        </q-card-section>
        <q-card-section class="q-pt-none" v-if="html">
            <div v-html="html"></div>
        </q-card-section>
        <q-card-actions align="right">
            <q-btn flat label="OK" color="primary" v-close-popup aria-label="OK" />
        </q-card-actions>
    </q-card>
</template>
<script setup>
import { toRefs } from "vue";
const props = defineProps({
    name: { type: String, default: null },
    html: { type: String, default: null }
})

const { name, html } = toRefs(props)

</script>
<style>
 .question{
  font-weight: 600;
  padding-bottom:2px !important;
  padding-top: 8px;
}

.answer{
  padding-bottom: 1px;
  padding-top: 3px;
}
.help-img{
    max-width: 750px;
}
</style>